import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceLine } from '../../../models/invoice-line';
import { InvoiceLinesService } from '../../services/invoice-lines.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
	selector: 'app-invoice-line-form',
	templateUrl: 'invoice-line-form.template.html'
})

/**
 * Component used for creating and updating InvoiceLines
 */
export class InvoiceLineFormComponent
{
	@Input() invoiceId: number = null;
	@Input() invoiceLine: InvoiceLine = new InvoiceLine();

	@Output() onClose = new EventEmitter();
	@Output() onInvoiceLineSave = new EventEmitter<InvoiceLine>();

	errors = {};

	/**
	 * InvoiceLineFormComponent constructor
	 *
	 * @param {InvoiceLinesService} invoiceLinesService
	 */
	constructor(private invoiceLinesService: InvoiceLinesService)
	{
	}

	/**
	 * Closes and resets the form
	 *
	 * @return void
	 */
	close()
	{
		this.invoiceLine = new InvoiceLine();
		this.onClose.emit();
	}

	/**
	 * Saves the current InvoiceLine. Throws onInvoiceLineSave event when successful
	 *
	 * @return void
	 */
	saveInvoiceLine()
	{
		if (this.invoiceId) {
			this.invoiceLine.invoice_id = this.invoiceId;
		}

		if (this.invoiceLine.id) { // Update invoice line
			this.invoiceLinesService.updateInvoiceLine(this.invoiceLine.id, this.invoiceLine).subscribe(
				data => {
					this.onInvoiceLineSave.emit(data);
					this.invoiceLine = new InvoiceLine();
				},
				err => {
					if (err instanceof HttpErrorResponse) {
						this.errors = err.error.message;
					}
				}
			);
		}
		else { // Create new invoice line
			this.invoiceLinesService.storeInvoiceLine(this.invoiceLine).subscribe(
				data => {
					this.onInvoiceLineSave.emit(data);
					this.invoiceLine = new InvoiceLine();
				},
				err => {
					if (err instanceof HttpErrorResponse) {
						this.errors = err.error.message;
					}
				}
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-line/invoice-line-form.component.ts